import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    Grid,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Switch,
    FormControlLabel,
    IconButton,
    Divider,
    Stack
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";


import { rtdb, storage } from "../../services/firebase";
import { ref, set, get } from "firebase/database";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import { useNavigate } from "react-router-dom";


export default function ProductForm() {

    const [id, setId] = useState("");
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loadingData, setLoadingData] = useState(true);

    const navigate = useNavigate();


    const [saving, setSaving] = useState(false);

    const [nome, setNome] = useState("");
    const [preco, setPreco] = useState("");
    const [isPromo, setIsPromo] = useState(false);
    const [precoPromo, setPrecoPromo] = useState("");

    const [marca, setMarca] = useState("");
    const [categoria, setCategoria] = useState("");

    const [descricao, setDescricao] = useState("");

    const [imagens, setImagens] = useState([]);
    const [variacoes, setVariacoes] = useState([{ nome: "", quantidade: "" }]);
    const [specs, setSpecs] = useState([{ key: "", value: "" }]);

    useEffect(() => {
        const random = Math.random().toString(36).substring(2, 10).toUpperCase();
        setId(random);
        carregarMarcasECategorias();
    }, []);

    async function carregarMarcasECategorias() {
        try {
            const appSnap = await get(ref(rtdb, "app"));
            if (appSnap.exists()) {
                const data = appSnap.val();
                setBrands(Array.isArray(data.brands) ? data.brands.map((nome) => ({ id: nome.toLowerCase().replace(/\s+/g, "_"), nome })) : []);
                setCategories(Array.isArray(data.category) ? data.category.map((nome) => ({ id: nome.toLowerCase().replace(/\s+/g, "_"), nome })) : []);
            }
        } catch (err) {
            console.error("Erro ao carregar marcas e categorias:", err);
        } finally {
            setLoadingData(false);
        }
    }

    const handleImages = (e) => {
        const files = Array.from(e.target.files);
        if (files.length + imagens.length > 5) return alert("Máximo 5 imagens");
        setImagens([...imagens, ...files]);
    };

    const formatMoney = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, "");
        value = (value / 100).toFixed(2).replace(".", ",");
        return "R$ " + value.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    async function uploadProductImages(productId, files) {
      const urls = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const imageRef = storageRef(
          storage,
          `products/${productId}/${Date.now()}_${file.name}`
        );

        await uploadBytes(imageRef, file);

        const downloadURL = await getDownloadURL(imageRef);
        urls.push(downloadURL);
      }

      return urls;
    }

    async function handleSave() {

        if (imagens.length < 1 || imagens.length > 5) {
          alert("Adicione no mínimo 1 e no máximo 5 imagens do produto.");
          return;
        }

        if (!nome || !marca || !categoria || !preco) {
            alert("Preencha todos os campos obrigatórios.");
            return;
        }

        setSaving(true);

        const imageUrls = await uploadProductImages(id, imagens);

        const data = {
            id,
            nome,
            marca,
            categoria,
            descricao,
            variacoes: variacoes.filter(v => v.nome),
            precos: {
                normal: preco,
                isPromo,
                promo: isPromo ? precoPromo : null
            },
            imagens: imageUrls,
            specs: specs.filter(s => s.key),
            createdAt: Date.now()
        };

        try {
            await set(ref(rtdb, `products/${id}`), data);

            alert("Produto criado com sucesso!");


            const newId = Math.random().toString(36).substring(2, 10).toUpperCase();
            setId(newId);

            setNome("");
            setMarca("");
            setCategoria("");
            setDescricao("");

            setPreco("");
            setIsPromo(false);
            setPrecoPromo("");

            setImagens([]);
            setVariacoes([{ nome: "", quantidade: "" }]);
            setSpecs([{ key: "", value: "" }]);

            navigate("/admin/produtos");

        } catch (err) {
            console.error(err);
            alert("Erro ao salvar produto!");
        }

        setSaving(false);
    }

    return (
        <Box sx={{ ml: 32, mt: 4, pr: 4 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                Criar Produto
            </Typography>

            <Paper elevation={1} sx={{ p: 4, borderRadius: 3 }}>

                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Informações do Produto
                </Typography>

                <Grid container spacing={3} alignItems="center">

                    {/* ID */}
                    <Grid item xs={12} md={3}>
                        <TextField
                            label="ID"
                            fullWidth
                            value={id}
                            disabled
                            InputLabelProps={{ shrink: true }}
                            sx={{ width: 300 }}
                        />
                    </Grid>

                    {/* Nome */}
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Nome do Produto"
                            placeholder="Nome do produto"
                            fullWidth
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{
                                width: 300,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        />
                    </Grid>

                    {/* Marca */}
                    <Grid item xs={12} md={4}>
                        <FormControl
                            fullWidth
                            sx={{
                                width: 300,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        >
                            <InputLabel shrink>Marca</InputLabel>
                            <Select
                                value={marca}
                                displayEmpty
                                onChange={(e) => setMarca(e.target.value)}
                                sx={{ height: 56 }}
                                disabled={loadingData}
                            >
                                <MenuItem value=""><em>Selecione uma marca</em></MenuItem>
                                {brands.map(b => (
                                    <MenuItem key={b.id} value={b.nome}>{b.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Categoria */}
                    <Grid item xs={12} md={4}>
                        <FormControl
                            fullWidth
                            sx={{
                                width: 300,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        >
                            <InputLabel shrink>Categoria</InputLabel>
                            <Select
                                value={categoria}
                                displayEmpty
                                onChange={(e) => setCategoria(e.target.value)}
                                sx={{ height: 56 }}
                                disabled={loadingData}
                            >
                                <MenuItem value=""><em>Selecione uma categoria</em></MenuItem>
                                {categories.map(c => (
                                    <MenuItem key={c.id} value={c.nome}>{c.nome}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Descrição do Produto"
                            placeholder="Digite uma descrição detalhada..."
                            fullWidth
                            multiline
                            minRows={4}
                            maxRows={8}
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                            sx={{
                                minWidth: 500,
                                maxWidth: 600,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        />
                    </Grid>

                </Grid>




                <Divider sx={{ my: 4 }} />


                {/* ========================  VARIAÇÕES ======================== */}
                {categoria && (
                    <>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            Variações ({categoria === "vape" ? "Cores" : "Sabores"})
                        </Typography>

                        {variacoes.map((v, i) => (
                            <Grid container spacing={2} key={i} sx={{ mb: 1 }}>

                                <Grid item xs={12} md={5}>
                                    <TextField
                                        label={categoria === "vape" ? "Cor" : "Sabor"}
                                        fullWidth
                                        value={v.nome}
                                        onChange={e => {
                                            const arr = [...variacoes];
                                            arr[i].nome = e.target.value;
                                            setVariacoes(arr);
                                        }}
                                        sx={{
                                            width: 300,
                                            "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                            "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                            "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                        }}

                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <TextField
                                        label="Quantidade"
                                        fullWidth
                                        value={v.quantidade}
                                        onChange={e => {
                                            const onlyNums = e.target.value.replace(/\D/g, ""); // remove qualquer coisa que não seja número
                                            const arr = [...variacoes];
                                            arr[i].quantidade = onlyNums;
                                            setVariacoes(arr);
                                        }}
                                        inputProps={{
                                            inputMode: "numeric",     // teclado numérico no mobile
                                            pattern: "[0-9]*"         // só permite dígitos
                                        }}
                                        sx={{
                                            width: 300,
                                            "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                            "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                            "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
                                    <IconButton onClick={() => setVariacoes(variacoes.filter((_, idx) => idx !== i))}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Grid>

                            </Grid>
                        ))}

                        <Button startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => setVariacoes([...variacoes, { nome: "", quantidade: "" }])}>
                            Adicionar Variação
                        </Button>

                    </>
                )}


                <Divider sx={{ my: 4 }} />


                {/* ========================  VALORES DO PRODUTO ======================== */}
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Valores do Produto
                </Typography>

                <Grid container spacing={3} alignItems="center">

                    {/* Preço */}
                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Preço"
                            placeholder="R$ 0,00"
                            fullWidth
                            value={preco}
                            onChange={(e) => setPreco(formatMoney(e.target.value))}
                            InputLabelProps={{ shrink: true }}
                            sx={{
                                width: 300,
                                "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                            }}
                        />
                    </Grid>

                    {/* Promoção */}
                    <Grid item xs={12} md={3} sx={{ display: "flex", alignItems: "center" }}>
                        <FormControlLabel
                            control={<Switch checked={isPromo} onChange={(e) => setIsPromo(e.target.checked)} />}
                            label="Promoção?"
                        />
                    </Grid>

                    {/* Preço Promocional */}
                    {isPromo && (
                        <Grid item xs={12} md={3}>
                            <TextField
                                label="Preço Promocional"
                                placeholder="R$ 0,00"
                                fullWidth
                                value={precoPromo}
                                onChange={(e) => setPrecoPromo(formatMoney(e.target.value))}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>
                    )}

                </Grid>


                <Divider sx={{ my: 4 }} />



                {/* ========================  ESPECIFICAÇÕES ======================== */}
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Especificações</Typography>

                {specs.map((s, i) => (
                    <Grid container spacing={2} key={i} sx={{ mb: 1 }}>
                        <Grid item xs={12} md={4}>
                            <TextField label="Título" fullWidth value={s.key}
                                onChange={e => {
                                    const arr = [...specs];
                                    arr[i].key = e.target.value;
                                    setSpecs(arr);
                                }}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField label="Valor" fullWidth value={s.value}
                                onChange={e => {
                                    const arr = [...specs];
                                    arr[i].value = e.target.value;
                                    setSpecs(arr);
                                }}
                                sx={{
                                    width: 300,
                                    "& .MuiInputLabel-root": { color: "#777", fontWeight: 500 },
                                    "& .MuiInputLabel-root.Mui-focused": { color: "#0A2A79" },
                                    "& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "#0A2A79" }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton onClick={() => setSpecs(specs.filter((_, idx) => idx !== i))}>
                                <DeleteIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                ))}

                <Button startIcon={<AddIcon />} sx={{ mt: 1 }} onClick={() => setSpecs([...specs, { key: "", value: "" }])}>
                    Adicionar Especificação
                </Button>


                <Divider sx={{ my: 4 }} />


                {/* ========================  IMAGENS ======================== */}
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>Imagens (1–5)</Typography>

                <Button variant="outlined" component="label" sx={{ mb: 2 }}>
                    Selecionar Imagens
                    <input hidden type="file" multiple accept="image/*" onChange={handleImages} />
                </Button>


                <Stack direction="row" spacing={2} flexWrap="wrap">
                    {imagens.map((img, i) => (
                        <Box key={i} sx={{ position: "relative" }}>
                            <img
                                src={URL.createObjectURL(img)}
                                alt=""
                                style={{ width: 100, height: 100, borderRadius: 8, objectFit: "cover", border: "1px solid #ccc" }}
                            />
                            <IconButton
                                size="small"
                                onClick={() => setImagens(imagens.filter((_, idx) => idx !== i))}
                                sx={{
                                    position: "absolute",
                                    top: -10,
                                    right: -10,
                                    bgcolor: "white",
                                    boxShadow: 2
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    ))}
                </Stack>

                {/* ========================  BOTÃO SALVAR ======================== */}
                <Box sx={{ textAlign: "right", mt: 4 }}>
                    <Button
                        variant="contained"
                        size="large"
                        sx={{ px: 4, py: 1.5 }}
                        onClick={handleSave}
                        disabled={saving}
                    >
                        {saving ? "Salvando..." : "Salvar Produto"}
                    </Button>
                </Box>

            </Paper>
        </Box>
    );
}
